import { Box, Typography } from '@mui/material'
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

export const TermsAndConditionsButton: FunctionComponent<{ color?: string }> = ({ color }) => {

  const termsLink = 'https://terms-and-conditions-gaia.s3.eu-west-2.amazonaws.com/live/gaia-carbon-terms-and-conditions.pdf'

  return (
    <Box component={Link} to={termsLink} target='_blank' style={{ cursor: 'pointer', display: 'inline' }}>
      <Typography sx={{ textDecoration: 'underline', color: color ? color : 'text.primary', display: 'inline' }}> Terms and Conditions</Typography>
    </Box >
  )
}